"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFromArray = removeFromArray;
function removeFromArray(array, itemsToRemove) {
    return array.filter((item) => !itemsToRemove.includes(item));
}
//# sourceMappingURL=remove-from-array.js.map